import styled, { css } from 'styled-components';

export const StyledLayout = styled.div`
  ${({ $showlayout }) =>
    $showlayout
      ? css`
          padding: 26px 30px 60px;

          @media (min-width: 1200px) {
            padding: 26px 30px 60px 80px;
            transition: all 0.3s ease-in-out;

            .sidebar-active & {
              padding: 26px 30px 60px 320px;
            }
          }
          @media (min-width: 1400px) {
            .sidebar-active & {
              padding: 26px 30px 60px 370px;
            }
          }
        `
      : css`
          padding: 0px;
        `}
  .children {
    width: 100%;
    ${({ $showlayout }) =>
      $showlayout
        ? css`
            min-height: calc(100dvh - 32px);
            display: flex;
            flex-direction: column;
          `
        : css`
            /* background: #fafcff; */
          `}
  }
`;
